import order from './modules/order'
import chatGPTPop from "@/store/modules/ChatGPTPop";
import disney from './modules/disney'
import userCenter from "@/store/modules/UserCenter";
import perplexityPop from './modules/perplexityPop';
import aiTool from '@/store/modules/AiTool'

let Vuex;

// console.log("当前环境变量 VUE_APP_ENV:", process.env.VUE_APP_ENV);  // 输出环境变量值，帮助调试

if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 vuex");
    Vuex = require('vuex');
    globalThis.Vuex = Vuex;  // 将 Vuex 设为全局变量，供其他模块使用
} else {
    // console.log("获取 cdn vuex");
    Vuex = window.Vuex;  // 从全局对象中获取 Vuex，CDN 已加载到页面中
}

const {createStore} = Vuex;

// console.log("初始化store")
export default createStore({
    state: {
        // 在这里定义您的应用状态
        auth: {
            token: localStorage.getItem('token') || null
        },
        // 全局刷新标识
        refreshFlag: 0,
        carListShow: false,
        loadingFlag: false,
        carList: null,
        priceGroupByIntervalType: null,
        userInfo: null,
        kodepayShow: false,
        renewOrder: false,
        orderActiveIndex: "orderHistory",
        subscriptionParam: null,
        currency: null,
        indexFlag: 'index',
        oldTransactionKey: null,
        openCarListFlag: false,
        sellable: true
    },
    getters: {
        // 在这里定义计算属性
        token: state => state.auth.token,
        refreshFlag: state => state.refreshFlag,
        carListShow: state => state.carListShow,
        loadingFlag: state => state.loadingFlag,
        carList: state => state.carList,
        priceGroupByIntervalType: state => state.priceGroupByIntervalType,
        userInfo: state => state.userInfo,
        kodepayShow: state => state.kodepayShow,
        renewOrder: state => state.renewOrder,
        orderActiveIndex: state => state.orderActiveIndex,
        subscriptionParam: state => state.subscriptionParam,
        currency: state => state.currency,
        indexFlag: state => state.indexFlag,
        oldTransactionKey: (state) => state.oldTransactionKey,
        openCarListFlag: (state) => state.openCarListFlag,
        sellable: (state) => state.sellable
    },
    mutations: {
        // 在这里定义修改状态的方法
        setTokenStore(state, value) {
            state.auth.token = value;
            localStorage.setItem('token', value);
        },
        removeTokenStore(state) {
            localStorage.removeItem('token');
        },
        removeUsrInfo(state) {
            localStorage.removeItem('userInfo')
        },
        incrementRefreshKey(state) {
            state.refreshFlag = state.refreshFlag + 1;
        },
        setCarListShow(state, value) {
            console.log("state.carListShow: ", value);
            state.carListShow = value
        },
        setLoadingFlag(state, flag) {
            state.loadingFlag = flag;
        },
        setCarList(state, payload) {
            state.carList = payload;
        },
        setOpenCarListFlag(state, payload) {
            console.log("state.openCarListFlag: ", payload);
            state.openCarListFlag = payload
        },
        setPriceGroupByIntervalType(state, value) {
            state.priceGroupByIntervalType = value;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        },
        setKodepayShow(state, value) {
            state.kodepayShow = value;
        },
        setRenewOrder(state, value) {
            state.renewOrder = value;
        },
        setOrderActiveIndex(state, value) {
            state.orderActiveIndex = value;
        },
        setSubscriptionParam(state, value) {
            state.subscriptionParam = value;
        },
        setCurrency(state, value) {
            state.currency = value;
        },
        updateIndexFlag(state, value) {
            state.indexFlag = value;
        },
        setOldTransactionKey(state, oldTransactionKey) {
            state.oldTransactionKey = oldTransactionKey;
        },
        setSellable(state, sellable) {
            state.sellable = sellable;
        }
    },
    actions: {
        // 在这里定义异步操作或复杂逻辑
        updateTokenStore({commit}, value) {
            commit('setTokenStore', value);
        },
        removeTokenStore({commit}) {
            commit('removeTokenStore');
        },
        removeUserInfo({commit}) {
            commit('removeUsrInfo');
        },
        triggerRefresh({commit}) {
            commit('incrementRefreshKey')
        },
        updateCarListShow({commit}, value) {
            console.log("carListShow:", value);
            commit('setCarListShow', value)
        },
        updateLoadingFlag({commit}, flag) {
            commit('setLoadingFlag', flag);
        },
        updateOpenCarListFlag({commit}, flag) {
            console.log("openCarListFlag: ", flag);
            commit("setOpenCarListFlag", flag);
        },
        updateUserInfoStore({commit}, userInfo) {
            commit('setUserInfo', userInfo);
        },
        updateKodepayShow({commit}, kodepayShow) {
            commit('setKodepayShow', kodepayShow);
        },
        updateRenewOrderState({commit}, renewOrder) {
            commit('setRenewOrder', renewOrder);
        },
        updateOrderActiveIndex({commit}, orderActiveIndex) {
            commit('setOrderActiveIndex', orderActiveIndex);
        },
        updateSubscriptionParam({commit}, payload) {
            commit('setSubscriptionParam', payload)
        },
        updateCurrency({commit}, payload) {
            commit('setCurrency', payload);
        },
        checkLocationUrl({commit}, payload) {
            commit('updateIndexFlag', payload);
        },
        updateOldTransactionKey({commit}, oldTransactionKey) {
            commit('setOldTransactionKey', oldTransactionKey);
        },
        updateCarList({commit}, carList) {
            commit('setCarList', carList);
        },
        updatePriceGroupByIntervalType({commit}, priceGroupByIntervalType) {
            commit('setPriceGroupByIntervalType', priceGroupByIntervalType);
        },
        updateSellable({commit}, sellable) {
            commit('setSellable', sellable);
        }
    },
    modules: {
        // 将状态管理逻辑拆分成更小的、独立的模块
        order,
        chatGPTPop,
        disney,
        userCenter,
        perplexityPop,
        aiTool
    }
})